import React from "react";
import Heading from "../../components/heading";
import styles from "./about.module.scss";

const AboutPage = () => {
  return (
    <div className={styles["wrapper"]}>
      <Heading
        heading="About Us"
        subheading="  Headquartered at Delhi beginning around 2022 doing specialized hiring.
        Catering wide scope of Industries with the emphasis on giving BEST
        Quality Human Assets. We are Shivant HR Consultancy  which has been in
        association with different top of the line associations in IT/Software,
        Banking, Finance, Mutual Funds, Insurance (BFSI), Pharma/Agriculture and
        Other areas. We additionally have practical experience in Bulk hiring.
        We work contrastingly and particularly from different organizations. We
        trust in first understanding the requirements of clients and afterward
        chipping away at it. By breaking down the necessities it becomes simpler
        for us to shape Efficient techniques for Interviews and Assessments to
        shortlist the best Candidates for the Clients."
        subheadingClassname={styles["sub-heading"]}
      />
      <Heading
        heading="Why Us"
        subheading="   We believe in giving our best at every step of our work. If we have to
        put ourselves in one line we would say - “We are Shivant HR Consultancy,
        your royal path to reach your destination”."
        subheadingClassname={styles["sub-heading"]}
      />
      <Heading
        heading="Why we do it ?"
        subheading=" Shivant services is a highly acclaimed recruitment and executive search company providing discerning 
        talent recruitment services to a strong and large list of
         clientele in all major cities across India. Sourcing Strategy i
         nvolves drawing up a list of target companies from which to recruit and 
         utilising our network, along with our database then we list most potential
          candidates within target companies. We then contact candidates and share 
          the opportunity with them and draw their interest in the position."
          subheadingClassname={styles["sub-heading"]}
      />
    </div>
  );
};

export default AboutPage;
